import React, { useEffect } from 'react';
import S from './DetailModal.module.css';

const ImgModal = ({ isOpen, onClose, img }) => {

  const handleContentClick = (e) => {
    e.stopPropagation();
  };
  
  return (
    <div id={S.detailModalBack} onClick={onClose} style={{ display: isOpen ? 'flex' : 'none' }}>
      <div onClick={handleContentClick} className='center'>

        {img && <img src={img} className='w-90' />}
        
        <div style={{textAlign: 'right'}}>
          <button onClick={onClose} style={{color: 'black', fontSize: '1.1rem', borderRadius: '5px', cursor: 'pointer', marginRight: '20px'}}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );

};

export default ImgModal;